var _defs, _ellipse, _ellipse2, _ellipse3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRespectful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #2c2c2d;\n      }\n    "))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 250,
    cy: 246.32,
    rx: 19.64,
    ry: 19.62
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 315.48,
    cy: 246.32,
    rx: 19.64,
    ry: 19.62
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 184.52,
    cy: 246.32,
    rx: 19.64,
    ry: 19.62
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250,0C111.93,0,0,111.93,0,250s111.93,250,250,250,250-111.93,250-250S388.07,0,250,0ZM380.95,311.71c0,14.45-11.72,26.16-26.19,26.16h-26.19v36.53c0,5.83-7.05,8.74-11.18,4.62l-41.2-41.15h-130.95c-14.46,0-26.19-11.71-26.19-26.16v-130.79c0-14.45,11.73-26.16,26.19-26.16h209.52c14.47,0,26.19,11.71,26.19,26.16v130.79Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRespectful);
export default __webpack_public_path__ + "static/media/Respectful.834ce938d1c103fdbb392a1120b6f6ca.svg";
export { ForwardRef as ReactComponent };